import React from 'react';
import __ from "../../../i18n";
import roles from "../../../model-constants/user/roles";
import UserStatusView from "../../../widgets/user-status-view/UserStatusView";
import UserStatusEditor from "../../../editors/user-status/UserStatusEditor";
import UserRoleEditor from "../../../editors/user-role/UserRoleEditor";


function getColumnConfigs({updateItem, refreshData, refs}) {
    return [
        {
            key: 'status',
            name: null,
            sortable: true,
            renderValue: (value) => <UserStatusView value={value} showsLabel={false}/>,
            renderEditor: (item, onSubmittingChange, close) => {
                return <UserStatusEditor
                    recordId={item.id}
                    defaultValues={item}
                    onDone={values => {
                        updateItem(item.id, values);
                        close();
                    }}
                    onSubmittingChange={onSubmittingChange}
                    onCancel={close}
                />;
            }
        },
        {
            key: 'id',
            name: __('ID'),
            sortable: true
        },
        {
            key: 'full_name',
            name: __('Full name'),
            sortable: true
        },
        {
            key: 'email',
            name: __('Email'),
            sortable: true
        },
        {
            key: 'phone',
            name: __('Phone'),
            sortable: true
        },
        {
            key: 'role',
            name: __('Role'),
            sortable: true,
            renderValue: (value) => roles.get(value).label,
            renderEditor: (item, onSubmittingChange, close) => {
                return <UserRoleEditor
                    recordId={item.id}
                    defaultValues={item}
                    onDone={values => {
                        updateItem(item.id, values);
                        close();
                    }}
                    onSubmittingChange={onSubmittingChange}
                    onCancel={close}
                />;
            }
        },
    ];
}

export default {
    getColumnConfigs
};
